import dayjs from 'dayjs'

/**
 * Генерация смен по шаблону
 * @param {Object} template - шаблон смены
 * @param {String|Date} dateFrom - начало диапазона
 * @param {String|Date} dateTo - конец диапазона
 * @param {Object} workingHours - рабочие часы { start: 'HH:mm', end: 'HH:mm' }
 * @returns {Array} список смен
 */
export function generateShiftsFromTemplate(template, dateFrom, dateTo, workingHours) {
  const shifts = []
  const startDate = dayjs(dateFrom)
  const endDate = dayjs(dateTo)
  // Используем только поле `breaks` (массив)
  const breaks = Array.isArray(template.breaks) ? template.breaks : []

  let current = startDate.clone()

  // определяем паттерн
  switch (template.pattern) {
    case '5_2': {
      // 5 рабочих дней, 2 выходных
      while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
        if (current.day() === 0 || current.day() === 6) {
          current = current.add(1, 'day')
          continue
        }
        shifts.push(makeShift(current, workingHours, breaks))
        current = current.add(1, 'day')
      }
      break
    }
    case '2_2': {
      // 2 рабочих дня, 2 выходных
      while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
        // 2 рабочих
        for (let i = 0; i < 2 && (current.isBefore(endDate) || current.isSame(endDate, 'day')); i++) {
          shifts.push(makeShift(current, workingHours, breaks))
          current = current.add(1, 'day')
        }
        // 2 выходных
        current = current.add(2, 'day')
      }
      break
    }
    case '1_3': {
      // 1 рабочий день, 3 выходных
      while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
        // 1 рабочий
        shifts.push(makeShift(current, workingHours, breaks))
        current = current.add(1, 'day')
        // 3 выходных
        current = current.add(3, 'day')
      }
      break
    }
    case '1_2': {
      // 1 рабочий день, 2 выходных
      while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
        // 1 рабочий
        shifts.push(makeShift(current, workingHours, breaks))
        current = current.add(1, 'day')
        // 2 выходных
        current = current.add(2, 'day')
      }
      break
    }
    case '3_3': {
      // 3 рабочих дня, 3 выходных
      while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
        // 3 рабочих
        for (let i = 0; i < 3 && (current.isBefore(endDate) || current.isSame(endDate, 'day')); i++) {
          shifts.push(makeShift(current, workingHours, breaks))
          current = current.add(1, 'day')
        }
        // 3 выходных
        current = current.add(3, 'day')
      }
      break
    }
    default: {
      // если паттерн не известен — все дни рабочие
      while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
        shifts.push(makeShift(current, workingHours, breaks))
        current = current.add(1, 'day')
      }
    }
  }

  return shifts
}

/**
 * Создать смену
 */
function makeShift(date, workingHours, breaks) {
  return {
    date: date.format('YYYY-MM-DD'),
    start_time: workingHours.start,
    end_time: workingHours.end,
    breaks: (breaks || []).map(b => ({ ...b }))
  }
}
